import { Stack, useLocalSearchParams } from "expo-router";
import { RequireCameraKey } from "@src/components/web/RequireCameraKey.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { View, Text } from "@src/components";
import { DumpingSearchContent } from "@src/features/dumping/DumpingSearch.web";

function MissingBounds() {
  return (
    <View flex={1} justifyContent="center" alignItems="center">
      <Text textStyle="md/regular" color="textMuted">
        Open dumping search from scene compare to set the search window.
      </Text>
    </View>
  );
}

export default function DumpingSearchScreen() {
  const { tenantId, startTime, endTime } = useLocalSearchParams<{
    tenantId?: string;
    startTime?: string;
    endTime?: string;
  }>();

  return (
    <RequireCameraKey requireSiteId>
      {({ cameraKey, siteId }) => (
        <>
          <Stack.Screen options={{ headerShown: false }} />
          <WebLayout>
            {startTime && endTime && tenantId ?
              <DumpingSearchContent
                tenantId={tenantId}
                cameraKey={cameraKey}
                siteId={siteId}
                startTime={startTime}
                endTime={endTime}
              />
            : <MissingBounds />}
          </WebLayout>
        </>
      )}
    </RequireCameraKey>
  );
}
